<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="white">
          <v-icon small class="pr-4">mdi-menu-down</v-icon>
          Lägg till
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="item.action"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog :value="showCreateManually" width="600" persistent>
      <DelayCreateModal
        v-if="showCreateManually"
        @close="showCreateManually = false"
      />
    </v-dialog>

    <v-dialog :value="showDelayFromUtinModal" width="900" persistent>
      <DelayImportFromUtin
        v-if="showDelayFromUtinModal"
        @close="showDelayFromUtinModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import DelayCreateModal from './DelayCreateModal'
import DelayImportFromUtin from './DelayImportFromUtin'

export default {
  name: 'DelayCreateDropdown',

  components: {
    DelayCreateModal,
    DelayImportFromUtin
  },

  data: () => ({
    showCreateManually: false,
    showDelayFromUtinModal: false
  }),

  computed: {
    items() {
      return [
        {
          title: 'Manuellt',
          action: () => {
            this.showCreateManually = true
          }
        },
        {
          title: 'Från Här och Nu',
          action: () => {
            this.showDelayFromUtinModal = true
          }
        }
      ]
    }
  }
}
</script>
